import {
  GET_FINDOMESTIC_CHECK_FIRMA_V2,
  GET_INFOCERT_CERTIFICATO_V2,
  POST_FINDOMESTIC_FIRMA_CONTRATTI_V2,
  POST_INFOCERT_CERTIFICATO_V2,
} from '../../constants/ActionTypes'
import { fetchData } from '../Buy'

export const findomesticCheckFirmaV2 = (dispatch, getState) => {
  const state = getState()
  const { ordine } = state
  const idOrdine = ordine.id_ordine

  const uri = `${window.brumbrum.url_api}/findomestic/t/v2/firma/${idOrdine}/check`
  return dispatch(
    fetchData(GET_FINDOMESTIC_CHECK_FIRMA_V2)({
      callback: GET_FINDOMESTIC_CHECK_FIRMA_V2,
      errorMessage: GET_FINDOMESTIC_CHECK_FIRMA_V2,
      method: 'GET',
      uri,
      suppressErrorNotice: true,
    })
  )
}

export const getInfocertCertificatoV2 = (dispatch, getState) => {
  const state = getState()
  const { ordine } = state
  const idOrdine = ordine.id_ordine

  const uri = `${window.brumbrum.url_api}/findomestic/t/v2/firma/${idOrdine}/certificato`
  return dispatch(
    fetchData(GET_INFOCERT_CERTIFICATO_V2)({
      callback: GET_INFOCERT_CERTIFICATO_V2,
      errorMessage: GET_INFOCERT_CERTIFICATO_V2,
      method: 'GET',
      uri,
    })
  )
}

export const postInfocertCertificatoV2 = (dispatch, getState) => {
  const state = getState()
  const { ordine } = state
  const idOrdine = ordine.id_ordine
  const body = {
    ...state.findomestic.certificatoCheckBoxes,
    credentials: state.findomestic.credentials,
  }

  const uri = `${window.brumbrum.url_api}/findomestic/t/v2/firma/${idOrdine}/certificato`
  return dispatch(
    fetchData(POST_INFOCERT_CERTIFICATO_V2)({
      callback: POST_INFOCERT_CERTIFICATO_V2,
      errorMessage: POST_INFOCERT_CERTIFICATO_V2,
      method: 'POST',
      uri,
      body: JSON.stringify(body),
    })
  )
}

export const postContrattiV2 = (dispatch, getState) => {
  const state = getState()
  const { ordine } = state
  const idOrdine = ordine.id_ordine
  const assicurazioni = state.findomestic.firmaAssicurazioni.reduce(
    (acc, el) => {
      const assKey = el.key
      acc[`assicurazioni_${assKey}`] = Object.values(
        state.findomestic.firmaAssicurazioniCheckBoxes
      ).reduce((_acc, _el) => {
        const _assKey = _el.key
        // prendo solo le checkbox dell'assicurazione che sto riducendo
        if (_assKey.indexOf(assKey) === 0) {
          const checkKey = _assKey.replace(`${assKey}_`, '')
          _acc[checkKey] = { accepted: _el.accepted }
        }
        return _acc
      }, {})

      acc[`assicurazioni_${assKey}`].id = el.links[0].id

      return acc
    },
    {}
  )

  const body = {
    otp: state.findomestic.otp,
    /*
     * nella V2 non c'e' piu' infocert
    infocert: {
      ...state.findomestic.contrattoInfocertCheckBoxes,
      id: state.findomestic.contrattoInfocertLinks.length ? state.findomestic.contrattoInfocertLinks[0].id : null,
    },
    */
    findomestic: {
      ...state.findomestic.contrattoFindomesticCheckBoxes,
      id: state.findomestic.contrattoFindomesticLinks.length
        ? state.findomestic.contrattoFindomesticLinks[0].id
        : null,
    },
    credentials: state.findomestic.credentials,
    ...assicurazioni,
  }

  const uri = `${window.brumbrum.url_api}/findomestic/t/v2/firma/${idOrdine}/contratti`
  return dispatch(
    fetchData(POST_FINDOMESTIC_FIRMA_CONTRATTI_V2)({
      callback: POST_FINDOMESTIC_FIRMA_CONTRATTI_V2,
      errorMessage: POST_FINDOMESTIC_FIRMA_CONTRATTI_V2,
      method: 'POST',
      uri,
      body: JSON.stringify(body),
    })
  )
}
